const colorDefault: {
  [key: string]: string;
} = {
  "--black": "#000000",
  "--white": "#fff",
  "--standard": "#fafafa",
  "--disabled-text": "#b7bcc2",
  "--primary": "#1876f2",
  "--primary-hover": "#0057ff",
  "--primary-active": "#004fe8",
  "--error": "#ff234b",
  "--error-hover": "#cf0227",
  "--error-active": "#bd0325",
  "--warning": "#ff9600",
  "--warning-hover": "#ee8c03",
  "--warning-active": "#e38603",
  "--success": "#14ae5c",
  "--success-hover": "#149e55",
  "--success-active": "#048d44",
  "--secondary": "#8a8a8a",
  "--secondary-hover": "#8a8a8a",
  "--secondary-active": "#8a8a8a",
  "--dark": "#000000",
  "--dark-hover": "#243a50",
  "--dark-active": "#1c2b39",
  "--light": "#eeeeee",
  "--light-hover": "#e3e2e2",
  "--light-active": "#dcdada",
  "--disabled": "#eeeeee",
  "--disabled-hover": "#eee",
  "--disabled-active": "#eee",
  "--border": "#DBDBDB",
  "--border2": "#D9D9D9",
  "--shadow": "rgba(0, 0, 0, 0.0588235294)",
  "--default-hover": "#2f3f54",
  "--darkgreen": "#0071a6",
  "--bg1": "#28324a",
  "--bg2": "#0a4485",
};

export type TPalette = Record<string, any> & { mode?: "light" | "dark" };
function getCSSVariable(name: string) {
  return colorDefault[name];
}
const palette: TPalette = {
  mode: "light",
  common: {
    black: getCSSVariable("--black"),
    white: getCSSVariable("--white"),
    standard: getCSSVariable("--standard"),
    defaultHover: getCSSVariable("--default-hover"),
  },
  primary: {
    main: getCSSVariable("--primary"),
    hover: getCSSVariable("--primary-hover"),
    active: getCSSVariable("--primary-active"),
  },
  darkgreen: {
    main: getCSSVariable("--darkgreen"),
    hover: getCSSVariable("--darkgreen"),
    active: getCSSVariable("--darkgreen"),
  },
  normal: {
    main: getCSSVariable("--black"),
  },
  error: {
    main: getCSSVariable("--error"),
    hover: getCSSVariable("--error-hover"),
    active: getCSSVariable("--error-active"),
  },
  warning: {
    main: getCSSVariable("--warning"),
    hover: getCSSVariable("--warning-hover"),
    active: getCSSVariable("--warning-active"),
  },
  success: {
    main: getCSSVariable("--success"),
    hover: getCSSVariable("--success-hover"),
    active: getCSSVariable("--success-active"),
  },
  secondary: {
    main: getCSSVariable("--secondary"),
    hover: getCSSVariable("--secondary-hover"),
    active: getCSSVariable("--secondary-active"),
  },
  dark: {
    main: getCSSVariable("--dark"),
    hover: getCSSVariable("--dark-hover"),
    active: getCSSVariable("--dark-active"),
  },
  light: {
    main: getCSSVariable("--light"),
    hover: getCSSVariable("--light-hover"),
    active: getCSSVariable("--light-active"),
  },
  disabled: {
    main: getCSSVariable("--disabled"),
    hover: getCSSVariable("--disabled-hover"),
    active: getCSSVariable("--disabled-active"),
  },
  text: {
    main: getCSSVariable("--black"),
    secondary: getCSSVariable("--secondary"),
    white: getCSSVariable("--white"),
    disabled: getCSSVariable("--disabled-text"),
  },
  divider: "rgba(0, 0, 0, 0.12)",
  shadow: {
    main: getCSSVariable("--shadow"),
  },
  border: {
    main: getCSSVariable("--border"),
    secondary: getCSSVariable("--border2"),
  },
  bg: {
    bg1: getCSSVariable("--bg1"),
    bg2: getCSSVariable("--bg2"),
  },
};

export default palette;
